import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatLegacySelect as MatSelect } from '@angular/material/legacy-select';
import { AppService } from '@app/app.service';
import { SelectSearchLoad } from '@app/core/libraries/Dynamic-fields/components/select/classes/SelectSearchLoad.class';
import { FuiDestroyService } from '@services/destroy.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SelectService } from '../select-service.service';
import { BehaviorSubject, takeUntil } from 'rxjs';
import { InterfaceAppServiceRegister } from '@app/app.interface';

@Component({
    selector: 'app-select-search-load',
    templateUrl: './select-search-load.component.html',
    styleUrls: ['./../select.scss', '../../../../../shared/components/button/styles/button.scss'],
    providers: [SelectService, FuiDestroyService],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectSearchLoadComponent extends SelectSearchLoad implements OnInit {
    /**
     * Тултип для самого поля
     */
    public tooltip = new BehaviorSubject<string | null>(null);

    @ViewChild('matSelect', { static: false }) declare matSelect: MatSelect;

    constructor(
        @Inject(FuiDestroyService) protected _destroy$: FuiDestroyService,
        public appService: AppService,
        public deviceService: DeviceDetectorService,
        public service: SelectService,
        public http: HttpClient,
    ) {
        super(_destroy$, service, http, appService);
    }

    ngOnInit() {
        super.ngOnInit();
        this.service.field.getData.pipe(takeUntil(this._destroy$)).subscribe((options) => {
            this.tooltip.next(this.getCurrentName(options));
        });
        this.service.group
            .get(this.service.field.name)
            .valueChanges.pipe(takeUntil(this._destroy$))
            .subscribe(() => {
                this.service.field.getData.pipe(takeUntil(this._destroy$)).subscribe((options) => {
                    this.tooltip.next(this.getCurrentName(options));
                });
            });
    }

    public showSpinner() {
        this.service.isShowSpinner.next(true);
    }

    public hideSpinner() {
        this.service.isShowSpinner.next(false);
    }

    /**
     * Установка запрета изменения поля
     * @param disabled значение флага
     */
    setDisabled(disabled) {
        this.service.field.disabled = disabled;
        if (this.service.field.disabled) {
            this.service.group.get(this.service.field.name).disable({ onlySelf: true, emitEvent: false });
        } else {
            this.service.group.get(this.service.field.name).enable({ onlySelf: true, emitEvent: false });
        }
    }

    /**
     * Получить текущее имя
     */
    private getCurrentName(options: any[] | InterfaceAppServiceRegister[]): string | null {
        const value = this.service.group?.get(this.service.field.name).value;
        return options.find((item) => +item.id === +value)?.name ?? null;
    }
}
